/*
 * @Author: DT
 * @Date: 2023-02-13 11:00:20
 * @LastEditors: DT
 * @LastEditTime: 2023-02-17 14:11:38
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/app/yzg/index.js
 */
export const ylsqGroup = (r) => require.ensure([], () => r(require("./group/group.vue")), "group");
export const ylsqEditGroup = (r) => require.ensure([], () => r(require("./editGroup/editGroup.vue")), "editGroup");
export const ylsqCopy = (r) => require.ensure([], () => r(require("./copy/copy.vue")), "copy");
export const salesData = (r) => require.ensure([], () => r(require("./salesData/salesData.vue")), "salesData");
export const income = (r) => require.ensure([], () => r(require("./income/income.vue")), "income");
export const customerList = (r) => require.ensure([], () => r(require("./customerList/customerList.vue")), "customerList");
export const customer = (r) => require.ensure([], () => r(require("./customer/customer.vue")), "customer");
export const customerSee = (r) => require.ensure([], () => r(require("./customerSee/customerSee.vue")), "customerSee");
export const signScan = (r) => require.ensure([], () => r(require("./signScan/index.vue")), "signScan");
export const signBatch = (r) => require.ensure([], () => r(require("./signBatch/index.vue")), "signBatch");
// export const yzgCopy = (r) => require.ensure([], () => r(require("./copy/copy.vue")), "copy");
